import BreadCrumb from "@/components/global/BreadCrumb";
import Seo from "@/components/seo";
import { getPageContent } from "@/services/cms";
import { fetchHandshake } from "@/services/handshake";
import { unescapeHtml } from "@/utils/global";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function ContentPage({ content: data }) {
  const content = data?.items?.at(0);
  console.log(content);
  const {
    i18n: { language },
  } = useTranslation("common");
  
  const BreadCrumbItems = [
    {
      name: language == "en" ? "Home Delivery" : "الشحن والتوصيل والاستلام",
      url: "/home-delivery",
      active: true,
      key: "home-delivery",
    },
  ];

  return (
    <div className="overflow-x-hidden awnCMSPage custom-pages">
      <Seo
        title={content?.meta_title || content?.title || ""}
        description={content?.meta_description || ""}
        keywords={content?.meta_keyword || ""}
        // image={content?._media_?.image?.at(0)?.image || ""}
      />
      <BreadCrumb items={BreadCrumbItems} />
      <div className="px-20 py-10 max-sm:px-4 max-sm:text-xs max-sm:py-4">
        <div
          dangerouslySetInnerHTML={{
            __html: unescapeHtml(content?.content)
              ?.replaceAll(
                '"{{media url="',
                `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
              )
              ?.replaceAll(`/media/" `, "/media/")
              ?.replaceAll('"}}"', "")
              ?.replaceAll(
                "{{media url=",
                `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
              )
              ?.replaceAll("}}", "")?.replaceAll("'", ""),
          }}
        />
      </div>
    </div>
  );
}

export async function getServerSideProps({ locale, req, res }) {
  // get handshake from cookies or generate new handshake
  const handshake = await fetchHandshake({ req, res, locale });

  const pageId = locale === "en" ? 14 : 15;
  const { data } = await getPageContent(handshake, pageId, locale);
  console.log("params=============================", data);
  if (data?.data?.items?.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      locale,
      content: data?.data,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
